import { useState } from "react";
import "./stylesFinance.css";

import CustomDatePicker from "../../CommonComponents/CustomDatePicker/CustomDatePicker";

import { DownloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { Select, Table } from "antd";

function Finance() {
  const todayRange = [dayjs(), dayjs()];
  const [sportsBookDates, setSportsBookDates] = useState(todayRange);

  const data = [
    {
      id: "#22829290",
      amount: "$ 5,000.00",
      fee: "$ 20,00",
      salesTax: "$ 20,00",
      purpose: "Deposit",
      status: "In Progress",
      date: "Oc 05, 20,0024 12:34 PM",
      location: "2972 W 115th St, Los Angeles, CA 90044",
    },
    {
      id: "#22829290",
      amount: "$ 5,000.00",
      fee: "$ 20,00",
      salesTax: "$ 20,00",
      purpose: "Withdrawal",
      status: "Completed",
      date: "Oc 05, 2024 12:34 PM",
      location: "2839 E 116th St, Los Angeles, CA 90042",
    },
    {
      id: "#22829290",
      amount: "$ 5,000.00",
      fee: "$ 20,00",
      salesTax: "$ 20,00",
      purpose: "Deposit",
      status: "Completed",
      date: "Oc 05, 2024 12:34 PM",
      location: "2839 E 116th St, Los Angeles, CA 90042",
    },
    {
      id: "#22829290",
      amount: "$ 5,000.00",
      fee: "$ 20,00",
      salesTax: "$ 20,00",
      purpose: "Withdrawal",
      status: "In Progress",
      date: "Oc 05, 2024 12:34 PM",
      location: "2839 E 116th St, Los Angeles, CA 90042",
    },
    {
      id: "#22829290",
      amount: "$ 5,000.00",
      fee: "$ 20,00",
      salesTax: "$ 20,00",
      purpose: "Deposit",
      status: "In Progress",
      date: "Oc 05, 20,0024 12:34 PM",
      location: "2972 W 115th St, Los Angeles, CA 90044",
    },
    {
      id: "#22829290",
      amount: "$ 5,000.00",
      fee: "$ 20,00",
      salesTax: "$ 20,00",
      purpose: "Withdrawal",
      status: "Completed",
      date: "Oc 05, 2024 12:34 PM",
      location: "2839 E 116th St, Los Angeles, CA 90042",
    },
    {
      id: "#22829290",
      amount: "$ 5,000.00",
      fee: "$ 20,00",
      salesTax: "$ 20,00",
      purpose: "Deposit",
      status: "Completed",
      date: "Oc 05, 2024 12:34 PM",
      location: "2839 E 116th St, Los Angeles, CA 90042",
    },
    {
      id: "#22829290",
      amount: "$ 5,000.00",
      fee: "$ 20,00",
      salesTax: "$ 20,00",
      purpose: "Withdrawal",
      status: "In Progress",
      date: "Oc 05, 2024 12:34 PM",
      location: "2839 E 116th St, Los Angeles, CA 90042",
    },
    {
      id: "#22829290",
      amount: "$ 5,000.00",
      fee: "$ 20,00",
      salesTax: "$ 20,00",
      purpose: "Deposit",
      status: "In Progress",
      date: "Oc 05, 20,0024 12:34 PM",
      location: "2972 W 115th St, Los Angeles, CA 90044",
    },
    {
      id: "#22829290",
      amount: "$ 5,000.00",
      fee: "$ 20,00",
      salesTax: "$ 20,00",
      purpose: "Withdrawal",
      status: "Completed",
      date: "Oc 05, 2024 12:34 PM",
      location: "2839 E 116th St, Los Angeles, CA 90042",
    },
    {
      id: "#22829290",
      amount: "$ 5,000.00",
      fee: "$ 20,00",
      salesTax: "$ 20,00",
      purpose: "Deposit",
      status: "Completed",
      date: "Oc 05, 2024 12:34 PM",
      location: "2839 E 116th St, Los Angeles, CA 90042",
    },
    {
      id: "#22829290",
      amount: "$ 5,000.00",
      fee: "$ 20,00",
      salesTax: "$ 20,00",
      purpose: "Withdrawal",
      status: "In Progress",
      date: "Oc 05, 2024 12:34 PM",
      location: "2839 E 116th St, Los Angeles, CA 90042",
    },
    {
      id: "#22829290",
      amount: "$ 5,000.00",
      fee: "$ 20,00",
      salesTax: "$ 20,00",
      purpose: "Deposit",
      status: "In Progress",
      date: "Oc 05, 20,0024 12:34 PM",
      location: "2972 W 115th St, Los Angeles, CA 90044",
    },
    {
      id: "#22829290",
      amount: "$ 5,000.00",
      fee: "$ 20,00",
      salesTax: "$ 20,00",
      purpose: "Withdrawal",
      status: "Completed",
      date: "Oc 05, 2024 12:34 PM",
      location: "2839 E 116th St, Los Angeles, CA 90042",
    },
    {
      id: "#22829290",
      amount: "$ 5,000.00",
      fee: "$ 20,00",
      salesTax: "$ 20,00",
      purpose: "Deposit",
      status: "Completed",
      date: "Oc 05, 2024 12:34 PM",
      location: "2839 E 116th St, Los Angeles, CA 90042",
    },
    {
      id: "#22829290",
      amount: "$ 5,000.00",
      fee: "$ 20,00",
      salesTax: "$ 20,00",
      purpose: "Withdrawal",
      status: "In Progress",
      date: "Oc 05, 2024 12:34 PM",
      location: "2839 E 116th St, Los Angeles, CA 90042",
    },
  ];

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id.localeCompare(b.id),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text, record) => (
        <span
          className="amount-text"
          style={{
            color: record.purpose === "Withdrawal" ? "#E74C3C" : "#71BF8A",
          }}
        >
          {record.amount}
        </span>
      ),
      sorter: (a, b) => a.amount.localeCompare(b.amount),
    },
    {
      title: "Fee",
      dataIndex: "fee",
      key: "fee",
      sorter: (a, b) => a.fee.localeCompare(b.fee),
    },
    {
      title: "Sales Tax",
      dataIndex: "salesTax",
      key: "salesTax",
      sorter: (a, b) => a.salesTax.localeCompare(b.salesTax),
    },
    {
      title: "Purpose",
      dataIndex: "purpose",
      key: "purpose",
      render: (text, record) => (
        <span
          className="purpose-text"
          style={{
            color: record.purpose === "Withdrawal" ? "#E74C3C" : "#71BF8A",
          }}
        >
          {text}
        </span>
      ),
      sorter: (a, b) => a.purpose.localeCompare(b.purpose),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => (
        <span
          className={`status-text ${record.status
            .toLowerCase()
            .split(" ")
            .join("-")}`}
        >
          {text}
        </span>
      ),
      sorter: (a, b) => a.status.localeCompare(b.status),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => a.date.localeCompare(b.date),
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      sorter: (a, b) => a.location.localeCompare(b.location),
    },
  ];

  
  return (
    <div className="players-finance-container">
      <div className="players-finance-header">
        <div className="players-finance-header-title">
          <h2>Transaction Log</h2>
        </div>
        <div className="players-finance-header-title-right">
          <CustomDatePicker
            getData={() => {}}
            dates={sportsBookDates}
            setDates={setSportsBookDates}
            showQuickSelect={true}
            showPresets={true}
          />
          <DownloadOutlined className="download-icon" />
        </div>
      </div>
      <div className="players-finance-content">
        <div className="players-finance-content-header">
          <div className="players-finance-content-header-select">
            <Select
              // value={formData.filterSegment}
              // onChange={(value) => handleFieldChange("filterSegment", value)}
              placeholder="Purpose"
              options={[
                {
                  value: "Deposit",
                  label: "Deposit ",
                },
                {
                  value: "Withdrawal",
                  label: "Withdrawal",
                },
              ]}
            />
          </div>
          <div className="players-finance-content-header-select">
            <Select
              // value={formData.filterSegment}
              // onChange={(value) => handleFieldChange("filterSegment", value)}
              placeholder="Status"
              options={[
                {
                  value: "Pending",
                  label: "Pending",
                },
                {
                  value: "Completed",
                  label: "Completed",
                },
                {
                  value: "Failed",
                  label: "Failed",
                },
              ]}
            />
          </div>
        </div>
        <div className="players-finance-content-body">
          <Table dataSource={data} columns={columns} scroll={{ x: 1500 }} />
        </div>
      </div>
    </div>
  );
}

export default Finance;
